import type { TruckCheckTask } from "./types";

export function truckCheckDisplayQuantity(task: TruckCheckTask): number {
  return task.verified && task.observedQuantity != null
    ? task.observedQuantity
    : task.startingQuantity ?? task.expectedQuantity ?? 0;
}

export function truckCheckDisplayExpiration(task: TruckCheckTask): string | null {
  return task.verified && task.observedExpirationDate !== undefined
    ? task.observedExpirationDate
    : task.startingExpirationDate ?? task.expectedExpirationDate ?? null;
}

export function truckCheckRelatedQuantity(task: TruckCheckTask, tasks: TruckCheckTask[]): number {
  if (task.taskType !== "item" || !task.catalogItemId) {
    return truckCheckDisplayQuantity(task);
  }

  return tasks
    .filter((candidate) => candidate.taskType === "item" && candidate.catalogItemId === task.catalogItemId)
    .reduce((sum, candidate) => sum + truckCheckDisplayQuantity(candidate), 0);
}

export function isTruckCheckTaskCurrentlyMissing(task: TruckCheckTask, tasks: TruckCheckTask[] = [task]): boolean {
  return task.taskType === "item" && truckCheckRelatedQuantity(task, tasks) <= 0;
}

export function truckCheckStatusChipLabel(
  task: TruckCheckTask,
  tasks: TruckCheckTask[] = [task]
): "Corrected" | "Deficient" | "OK" | null {
  if (!task.verified) return null;

  const missing = isTruckCheckTaskCurrentlyMissing(task, tasks);
  if (missing) return task.alertOnly ? null : "Deficient";
  if (task.resultStatus === "corrected") return "Corrected";
  if (task.resultStatus === "deficient") return "Deficient";
  return "OK";
}
